<template>
  <div class="user_wrap">
    <BreadCrumb crumb="内容审核"></BreadCrumb>
    <div class="top_bar">
        <el-row>
          <el-col :span="7">
            <el-input placeholder="请输入: 文章名称" v-model="title" class="input-with-select" size="small">
            </el-input>
          </el-col>
          <el-col :span="7" :offset='1'>
            <el-input placeholder="请输入: 频道" v-model="channel" class="input-with-select" size="small">
            </el-input>
          </el-col>
          <el-col :span="7" :offset='1'>
              <template>
                <el-select  size="small" v-model="status_list" placeholder="请选择状态">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
          </el-col>
      </el-row>
    </div>
<div class="top_bar">
      <el-row>
          <el-col :span="6">
            <el-date-picker
              v-model="begin"
              type="datetime"
              size='small'
              placeholder="选择开始时间">
            </el-date-picker>
          </el-col>
          <el-col :span="4">
            <el-date-picker
              v-model="end"
              type="datetime"
              size='small'
              placeholder="选择结束时间">
            </el-date-picker>
          </el-col>

          <el-col :span="5" >
            <div class="find" @click='fnGetData(1)'>查询</div>
          </el-col>
      </el-row>
    </div>


   <ContentAuditTable :skus="aSkuList" @fnResetTable="fnGetData(1)"></ContentAuditTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddSku from '@/components/widget/AddSku'
import ContentAuditTable from '@/components/widget/ContentAuditTable'
import cons from '@/components/constant'
import JSONbig from 'json-bigint'

export default {
  name: 'UserAudit',
  data () {
    return {
      options: [{
          value: '0',
          label: '草稿'
        }, {
          value: '1',
          label: '待审核'
        }, {
          value: '2',
          label: '审核通过'
        }, {
          value: '3',
          label: '审核失败'
        }, {
          value: '4',
          label: '已删除'
        }, {
          value: '5',
          label: '封禁'
        }],
      title:'',
      channel:'',
      status_list:'',
      begin:new Date(1970,0,1),
      end:new Date(),
      page:1,
      pages:8,
      pagesize:10,
      aSkuList:[],
    }
  },
  components:{
    BreadCrumb,
    ContentAuditTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/articles', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          //responseType: 'json',
          params:{
            page:num,
            per_page:this.pagesize,
            order_by: 'id',
            title: this.title,
            channel:this.channel,
            status_list:this.status_list===''?'2,3,5':this.status_list,
            begin: this.begin===null?null:this.formatTime(this.begin),
            end: this.end===null?null:this.formatTime(this.end)
          },
          transformResponse: [function (data) {
            return JSONbig.parse(data);
        }]
      })
      .then(dat=>{
          this.aSkuList = dat.data.data.articles;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    },
    formatTime: function(obj){
      let y = obj.getFullYear()
      let m = obj.getMonth()+1
      let d = obj.getDate()
      let h = obj.getHours()
      let min = obj.getMinutes()
      let s = obj.getSeconds()

      m = m < 10 ? '0'+m: m
      d = d < 10 ? '0'+d: d
      h = h < 10 ? '0'+h: h
      min = min < 10 ? '0'+min: min
      s = s < 10 ? '0'+s: s
      return y+'-'+m+'-'+d+' '+h+':'+min+':'+s
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto 10px;
  }


.batch_operation, .export_data {
  width: 80px;
  height: 32px;
  color: #fff;
  font: 12px/32px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.batch_operation:hover, .export_data:hover {
  background-color: rgb(252, 119, 121);
}


.batch_operation, .export_data, .find {
  width: 92px;
  height: 38px;
  color: #fff;
  font: 12px/38px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.find {
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-left: 140px;
}
.batch_operation:hover, .export_data:hover, .find:hover {
  background-color: rgb(252, 119, 121);
}



</style>



// WEBPACK FOOTER //
// src/components/pages/ContentAudit.vue